import TuneIcon from '@mui/icons-material/Tune';
import { Chip, IconButton, Stack, Tooltip } from '@mui/material';
import { type FC, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setLayoutEditScope } from '../../redux/reducers/layout.js';
import { isLayoutEditing } from '../../redux/selectors.js';

interface Props {
  scope: string;
}

const EditLayoutToggle: FC<Props> = ({ scope }) => {
  const dispatch = useDispatch();
  const editing = useSelector(useMemo(() => isLayoutEditing(scope), [scope]));

  const onToggle = () => {
    dispatch(setLayoutEditScope(editing ? null : scope));
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {editing && (
        <Chip
          label="EDITING"
          size="small"
          color="primary"
          variant="filled"
          sx={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', height: 22 }}
        />
      )}
      <Tooltip title={editing ? 'Done editing layout' : 'Edit layout'}>
        <IconButton
          color="inherit"
          onClick={onToggle}
          sx={{
            ...(editing && {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': { bgcolor: 'primary.dark' },
            }),
          }}
        >
          <TuneIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default EditLayoutToggle;
